<template>
  <!-- TODO сделать константу  -->
  <div id="interested-party-title" :class="interestedPartyTitleMobileClass">
    {{ interestPartyTitle }}
  </div>
  <div v-if="interestedParty.length" :class="interestPartyWrapperClass">
    <Interest
      v-for="(interest, idx) in interestedParty"
      :key="idx"
      :interest="interest"
    />
  </div>
  <div v-else :class="interestPartyWrapperClass">
    <!-- TODO сделать константу  -->
    <CardEmpty text="Новых интересантов пока нет" />
  </div>
</template>

<script>
import Interest from './Interest/Interest.vue'
import CardEmpty from './Interest/card/card-empty/CardEmpty.vue'

export default {
  name: 'InterestedParty',
  components: {
    Interest,
    CardEmpty,
  },
  props: {
    interestedParty: Array,
  },
  computed: {
    isMobileVersion() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    },
    interestPartyTitle() {
      return this.isMobileVersion ? 'Интересанты' : 'Интересанты:'
    },
    interestPartyWrapperClass() {
      return this.isMobileVersion ? 'interested-party-mobile' : 'interest-wid'
    },
    interestedPartyTitleMobileClass() {
      return {
        'interested-party-title-mobile': this.isMobileVersion,
        'platform-block--mobile': this.isMobileVersion,
        'interested-party-title': !this.isMobileVersion,
      }
    },
  },
}
</script>

<style scoped>
.interested-party-title {
  margin-bottom: 5px;
  font-weight: bold;
}
.interested-party-title-mobile {
  margin-left: 1rem;
}
.interest-wid {
  width: 40vw;
}
.interested-party-mobile {
  width: 95vw;
}
</style>
